module.exports = __webpack_public_path__ + "img/code.b68bd538.png";